// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autoComplete_wrapper {
  display: inline-block;
  position: relative;
}
.autoComplete_wrapper > ul {
  position: absolute;
  max-height: 226px;
  overflow-y: scroll;
  top: 100%;
  left: 0;
  right: 0;
  padding: 0;
  margin: 0.5rem 0 0 0;
  border-radius: 4px;
  background-color: var(--gjs-primary-color);
  border: 1px solid var(--gjs-primary-color);
  z-index: 1;
  outline: 0;
}
.autoComplete_wrapper > ul > li {
  padding: 10px 20px;
  list-style: none;
  text-align: left;
  border-radius: 3px;
  background-color: var(--gjs-primary-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.autoComplete_wrapper > ul > li:hover {
  cursor: pointer;
  background-color: var(--gjs-main-dark-color);
}
.autoComplete_wrapper > ul > li mark {
  background-color: transparent;
  color: var(--gjs-quaternary-color);
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/autocomplete.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;EAC1C,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,4CAA4C;AAC9C;AACA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,gBAAgB;AAClB","sourcesContent":[".autoComplete_wrapper {\n  display: inline-block;\n  position: relative;\n}\n.autoComplete_wrapper > ul {\n  position: absolute;\n  max-height: 226px;\n  overflow-y: scroll;\n  top: 100%;\n  left: 0;\n  right: 0;\n  padding: 0;\n  margin: 0.5rem 0 0 0;\n  border-radius: 4px;\n  background-color: var(--gjs-primary-color);\n  border: 1px solid var(--gjs-primary-color);\n  z-index: 1;\n  outline: 0;\n}\n.autoComplete_wrapper > ul > li {\n  padding: 10px 20px;\n  list-style: none;\n  text-align: left;\n  border-radius: 3px;\n  background-color: var(--gjs-primary-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.autoComplete_wrapper > ul > li:hover {\n  cursor: pointer;\n  background-color: var(--gjs-main-dark-color);\n}\n.autoComplete_wrapper > ul > li mark {\n  background-color: transparent;\n  color: var(--gjs-quaternary-color);\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
